module.exports = __webpack_public_path__ + "media/photo/Component 26 – 2-468d7bbf.png";